import { get } from 'lodash-es'
import SharedResource from '@/mixins/shared-resource'
import TickOrCross from '@/components/tick-or-cross'

export default {
  mixins: [SharedResource],
  components: {
    TickOrCross,
  },
  data() {
    return {
      tab: null,
    }
  },
  async mounted() {
    await this.findResource(this.$route.params.id).catch(error => {
      this.$router.push(this.redirectToIndexView())
      this.$notify({ type: 'error', text: 'Unable to retrieve resource', data: { error }, duration: -1 })
    })
  },
  computed: {
    resourceItems() {
      return this.resourceKeys.map(({ title, key, type = 'text' }) => ({
        title,
        type,
        value: get(this.resource, key, null),
      }))
    },
    breadcrumbs() {
      return [
        { text: this.resourceType, href: this.$router.resolve(this.redirectToIndexView()).href },
        { text: this.resourceName, disabled: true },
      ]
    },
  },
}
